// extracted by css-extract-rspack-plugin
export default {"box":"Spinner-module__box___wNBl8","ring":"Spinner-module__ring___qbe_t","spin":"Spinner-module__spin___vzAsf","small":"Spinner-module__small___tmfzP"};